export default __webpack_public_path__ + "static/media/bata-hombre.524fce04.png";